<template>
  <v-menu v-model="dropdownIsOpen" location="bottom center" transition="slide-y-transition" offset="4">
    <template #activator="{ props }">
      <v-btn v-if="! userConsultOnly" variant="text" icon size="small" v-bind="props">
        <v-icon>far fa-cog</v-icon>
        <v-tooltip :disabled="dropdownIsOpen" location="bottom" activator="parent">{{ $t('NAV.MANAGE') }}</v-tooltip>
      </v-btn>
    </template>

    <v-list density="compact">
      <v-list-item to="/manage#company" :active="false" class="px-3">
        <div class="px-1 d-flex align-center">
          <v-icon size="small" class="mr-2">far fa-building</v-icon>
          {{ $t('MANAGE.ACCOUNT') }}
        </div>
      </v-list-item>
      <v-list-item to="/manage#projects" :active="false" class="px-3">
        <div class="px-1 d-flex align-center">
          <v-icon size="small" class="mr-2">far fa-folder-open</v-icon>
          {{ $t('MANAGE.PROJECTS') }}
        </div>
      </v-list-item>
      <v-list-item to="/manage#profile" :active="false" class="px-3">
        <div class="px-1 d-flex align-center">
          <v-icon size="small" class="mr-2">far fa-user</v-icon>
          {{ $t('ACCOUNT.PROFILE') }}
        </div>
      </v-list-item>
      <v-list-item v-if="isAdmin" to="/manage#config" :active="false" class="px-3">
        <div class="px-1 d-flex align-center">
          <v-icon size="small" class="mr-2">far fa-cog</v-icon>
          {{ $t('MANAGE.CONFIGURATION') }}
        </div>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  import useUsersAccessRightStore from '@/stores/users/accessRight';

  export default {
    data() {
      return {
        dropdownIsOpen: null,
        usersAccessRightStore: useUsersAccessRightStore(),
      };
    },
    computed: {
      isAdmin() { return this.usersAccessRightStore.isAdmin; },
      userConsultOnly() { return this.usersAccessRightStore.isConsultOnly; },
    },
  };
</script>
